import { draftCombineUrl } from "../configs/AppSettings";

const APIURLConstants = {
  GET_ALL_APPLICATION_USERS: `${draftCombineUrl}/api/User/GetUsersList`,
  //GET_USER_PROFILE: "user/GetUserProfile",
  //GET_LOGGEDIN_USER_DETAILS: "user/GetUserDetails",
  GET_USER_PERMISSION_DETAILS: `${draftCombineUrl}/api/User/GetUserPermissionDetails`,
  SAVE_PLAYER_CAREER_STATS_STATS: `${draftCombineUrl}/api/PlayersCareerStats/SavePlayerStatsData`,
  GET_BALLOT_VOTES_PLAYERS_LIST: `${draftCombineUrl}/api/BallotVote/GetBallotVotePlayersListByTeamID`,
  GET_LEAGUE_NAMES: `${draftCombineUrl}/api/Common/GetEventNames`,
  GET_COMBINE_NAMES: `${draftCombineUrl}/api/Common/GetEventYears`,
  GET_COMBINE_NAMES_ID: (leagueid) =>
    `${draftCombineUrl}/api/Common/GetEventIdsByLeague/${leagueid}`,
  GET_ADMIN_PREF_MAX_VOTE_DETAILS: `${draftCombineUrl}/api/AdminPreferences/GetAdminPrefMaxVotesDetails`,
  INSERT_UPDATE_ADMIN_PREF_BALLOT_VOTE_COUNT: `${draftCombineUrl}/api/AdminPreferences/InsUpdAdminPrefBallotVoteCount`,
  GET_ADMIN_PREF_BALLOT_VOTING_DATE_TIME_DETAILS: `${draftCombineUrl}/api/AdminPreferences/GetAdminPrefBallotVotingDateTimeDetails`,
  INSERT_UPDATE_ADMIN_PREF_BALLOT_VOTING_DATE_TIME: `${draftCombineUrl}/api/AdminPreferences/InsUpdAdminPrefBallotVotingDateTime`,
  INSERT_BALLOT_VOTES_PLAYERS_LIST: `${draftCombineUrl}/api/BallotVote/ManageBallotVotesPlayersList`,
  GET_ADMIN_VIEW_BALLOT_VOTE_DETAILS: (eventId) =>
    `${draftCombineUrl}/api/BallotVote/GetAdminViewBallotVotingDetails/${eventId}`,
  GET_EVENT_NAME: (eventyear) =>
    `${draftCombineUrl}/api/Common/GetActiveEventNamesForDraftCombine?EventYear=${eventyear}`,
  GET_TEAM_WISE_ADMIN_VIEW_BALLOT_VOTE_DETAILS: (eventId) =>
    `${draftCombineUrl}/api/BallotVote/GetTeamWiseAdminViewBallotVotingDetails/${eventId}`,
  GET_TEAM_PLAYER_VOTED_DATA: (eventId) =>
    `${draftCombineUrl}/api/BallotVote/GetTeamAndPlayersViewBallotVotingDetails/${eventId}`,

  GET_PLAYERS_STATS_DATA: `${draftCombineUrl}/api/PlayersCareerStats/GetPlayerCareerStatsDataForComparison`,
  GET_PLAYERS_STATS_DATA_Percentile: `${draftCombineUrl}/api/PlayersCareerStats/GetPlayerAndGroupPercentileRank`,
  GET_PLAYERS_LIST_BY_EVENT_ID_YEAR: (eventId, userBy) =>
    `${draftCombineUrl}/api/Players/GetPlayersListByEventId/${eventId}`,
  GET_PLAYERS_LIST_PAGE_BY_EVENT_ID_YEAR: (eventId, userBy) =>
    `${draftCombineUrl}/api/Players/GetPlayersListForProfileList/${eventId}`,
  GET_PLAYERS_PROFILE_DATA: (id, eventId, userBy) =>
    `${draftCombineUrl}/api/Players/GetPlayersProfileData/${id}/${eventId}`,
  GET_COLLEGE_CONFERENCE_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/6`,
  GET_COLLEGE_CLASS_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/7`,
  GET_PLAYER_POSITIONS: `${draftCombineUrl}/api/Common/GetEnumerationDetails/8`,
  GET_PLAYER_COUNTRY_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/9`,
  GET_PLAYER_STATE_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/10`,
  GET_HIGH_SCHOOL_EVENTS_DATA: `${draftCombineUrl}/api/Common/GetEnumerationDetails/11`,
  GET_RANKINGS_DATA: `${draftCombineUrl}/api/Common/GetEnumerationDetails/12`,
  INSERT_UPDATE_PLAYER_PROFILE_DETAILS: `${draftCombineUrl}/api/Players/InsUpdPlayerProfileDetails`,
  INSERT_UPDATE_PLAYER_AGENT_DETAILS: `${draftCombineUrl}/api/Players/InsUpdPlayersAgentDetails`,
  INSERT_UPDATE_COLLEGE_DETAILS: `${draftCombineUrl}/api/Players/InsUpdCollegeDetails`,
  INSERT_UPDATE_PROF_EXPERIENCE_DETAILS: `${draftCombineUrl}/api/Players/InsUpdIntProfExperienceDetails`,
  INSERT_UPDATE_GLEAGUE_EXPERIENCE_DETAILS: `${draftCombineUrl}/api/Players/InsUpdGLeagueExperienceDetails`,
  INSERT_UPDATE_HIGH_SCHOOL_DETAILS: `${draftCombineUrl}/api/Players/InsUpdHighSchoolDetails`,
  INSERT_UPDATE_CLUB_PROGRAM_DETAILS: `${draftCombineUrl}/api/Players/InsUpdAAUClubDetails`,
  INSERT_UPDATE_INT_TEAM_EXP_DETAILS: `${draftCombineUrl}/api/Players/InsUpdNationalIntExpDetails`,
  INSERT_UPDATE_HIGH_SCHOOL_EVENTS: `${draftCombineUrl}/api/Players/InsUpdHighSchoolEventsDetails`,
  INSERT_UPDATE_RANKINGS: `${draftCombineUrl}/api/Players/InsUpdRankingsDetails`,
  UPDATE_PLAYER_HEADSHOT_URL: `${draftCombineUrl}/api/Players/UpdPlayersHeadshotURL`,
  GET_SPORTS_RADAR_PLAYER_DATA: `${draftCombineUrl}/api/PlayersCareerStats/GetSportsRadarPlayerDetail`,
  REFRESH_SPORTS_RADAR_PLAYER_DATA: `${draftCombineUrl}/api/PlayersCareerStats/RefreshPlayerDetails`,
  GET_PLAYER_STATS_DATA: `${draftCombineUrl}/api/PlayersCareerStats/GetPlayerStatsData`,
  GET_BALLOT_VOTED_TEAM_DETAILS_FOR_PLAYER: (playerId, eventId) =>
    `${draftCombineUrl}/api/BallotVote/GetBallotVotedTeamDetailsForPlayerByID/${playerId}/${eventId}`,
  GET_BALLOT_VOTED_Players_DETAILS_By_Team: (teamID, eventId) =>
    `${draftCombineUrl}/api/BallotVote/GetTeamBallotVotingDetails/${eventId}/${teamID}`,

  GET_PLAYER_PROFILE_DISPLAY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/21`,
  // GET_COMBINE_YEARS: `${draftCombineUrl}/api/Common/GetCombineYears`,
  GET_COMBINE_YEARS: `${draftCombineUrl}/api/Common/GetEventYears`,

  GET_TEAM_BALLOT_DASHBOARD_FLAG_FOR_TEAM_USER: `${draftCombineUrl}/api/Common/GetEnumerationDetails/28`,
  SUBMIT_BALLOT_VOTE_CONFIRMATION_EMAIL_TO_TEAM_USER: (eventId, teamId) =>
    `${draftCombineUrl}/api/BallotVote/BallotVoteSubmissionConfirmationEmailToTeamUser/${eventId}/${teamId}`,
  GET_ANTHROS_DATA_BY_PLAYER_ID: (eventId, playerId, userBy) =>
    `${draftCombineUrl}/api/Players/GetAnthrosDataByPlayerId/${eventId}/${playerId}/${userBy}`,
  GET_ANTHROS_Ranking_DATA_BY_PLAYER_ID: (eventId, playerId, userBy) =>
    `${draftCombineUrl}/api/Players/GetAnthrosRankDataByPlayerId/${eventId}/${playerId}/${userBy}`,
  GET_ANTHROS_Ranking_DATA_BY_PLAYER_Year: (eventId, playerId) =>
    `${draftCombineUrl}/api/Common/GetPlayerEventIds/${eventId}/${playerId}`,
  GET_CURRENT_ENABLED_BALLOT_VOTE_EVENT_DETAILS: `${draftCombineUrl}/api/BallotVote/GetCurrentEnabledBallotVoteEventDetails`,
  GET_ACTIVE_COMBINECENTRAL_EVENT_ID: `${draftCombineUrl}/api/Common/GetActiveCombineCentralEventId`,
  GET_ACTIVE_BALLOTVOTE_EVENT_ID: `${draftCombineUrl}/api/Common/GetActiveBallotVoteEventId`,
  GET_STORAGE_ACCESS_ENUMERATION_CONFIG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/24`,
  GET_PLAYER_FILE_DETAILS: `${draftCombineUrl}/api/Players/GetPlayerFilesDetails`,
  SAVE_PLAYER_FILE_DETAILS: `${draftCombineUrl}/api/Players/InsPlayerFilesDetails`,
  GET_PLAYERS_STRENGTH_AND_AGILITY_DATA: (eventId, playerId, userBy) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetPlayersStrengthAndAgilityData/${eventId}/${playerId}`,
  GET_PLAYERS_STRENGTH_AND_AGILITY_DATA_Ranking: (eventId, playerId, userBy) =>
    `${draftCombineUrl}/api/Players/GetAgilityRankDataByPlayerId/${eventId}/${playerId}`,
  GET_SHOOTING_DRILL_SUMMARY_BY_PLAYER_ID: (
    eventId,
    stationId,
    playerId,
    userBy
  ) =>
    `${draftCombineUrl}/api/ShootingDrills/GetShootingDrillSummaryByPlayerId/${eventId}/${stationId}/${playerId}`,
  GET_Full_Court_AND_Workout_Videos_PLAYER_ID: (eventId, stationId, playerId) =>
    `${draftCombineUrl}/api/Players/GetVideoMetaDataByPlayerId/${eventId}/${stationId}/${playerId}`,
  ///Leader Dashboard Strength And Agility
  GET_STRENGTH_AND_AGILITY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/31`,
  GET_LEADER_BOARD_NOTES: `${draftCombineUrl}/api/Common/GetEnumerationDetails/22`,
  GET_STRENGTH_AND_AGILITY_DATA: (eventId, stationId, state, userBy) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetStrengthAndAgilityLeaderBoardByStationId/${eventId}/${stationId}/${state}`,
  GET_ANTHROS_LEADER_BOARD_DATA: (eventId, stationId, userBy) =>
    `${draftCombineUrl}/api/AnthrosData/GetAnthrosLeaderBoardByStationId/${eventId}/${stationId}`,

  GET_SHOOTING_DRILLS_DATA: (eventId, stationId, userBy) =>
    `${draftCombineUrl}/api/ShootingDrills/GetShootingDrillLeaderBoardByStationId/${eventId}/${stationId}`,

  GET_FAV_PLAYERS_SHOOTING_DRILLS_DATA_BY_USER_NAME_AND_EVENTID: (
    eventId,
    userName
  ) =>
    `${draftCombineUrl}/api/ShootingDrills/GetShootingDrillLeaderBoardByLoggedInFavPlayers/${eventId}/${userName}`,

  GET_FAV_PLAYERS_SHOOTING_DRILLS_DATA_BY_EVENTID: (eventId, userBy) =>
    `${draftCombineUrl}/api/ShootingDrills/GetShootingDrillLeaderBoardByEventId/${eventId}`,

  GET_FAV_PLAYERS_STRENGTH_AND_AGILITY_DATA_BY_USER_NAME_AND_EVENTID: (
    eventId,
    userName
  ) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetLeaderboardAnthroSAAgilityByLoggedInFavPlayers/${eventId}/${userName}`,

  // GET_PLAYERS_STRENGTH_AND_AGILITY_DATA_BY_EVENTID: (eventId) =>
  //   `${draftCombineUrl}/api/StrengthAndAgility/GetLeaderboardAnthroAndStrengthAndAgilityByEventId/${eventId}`,

  DEL_PLAYER_FILE_DETAILS: `${draftCombineUrl}/api/Players/DelPlayerFilesDetails`,
  GET_FAV_PLAYERS_BY_USER_NAME_AND_EVENTID: (eventId, userName) =>
    `${draftCombineUrl}/api/Players/GetFavPlayersByUserNameAndEventId/${eventId}/${userName}`,

  INS_UPD_FAV_PLAYER: `${draftCombineUrl}/api/Players/InsUpFavPlayers`,
  GET_SHOOTING_DRILLS_OVERALL_SUMMARY_BY_PLAYER_ID: (
    eventId,
    playerId,
    userBy
  ) =>
    `${draftCombineUrl}/api/ShootingDrills/GetShootingDrillsOverAllSummaryByPlayerId/${eventId}/${playerId}`,
  POST_VALIDATE_USER: `${draftCombineUrl}/api/auth/ValidateUser`,
  GET_SIGNOUT_URL: `/User/GetSignoutURL`,
  GET_COMBINE_RESULTS_DISPLAY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/39`,
  GET_PLAYER_POD_DETAILS: `${draftCombineUrl}/api/Common/GetEnumerationDetails/42`,
  GET_SHAREPOINT_VIDEO_URL: `/api/video/sharepoint/`,
  GET_USER_UNIT_PREFERENCES_BY_USER_ID: (userId) =>
    `${draftCombineUrl}/api/Common/GetUnitPreferencesForUser/${userId}`,
  INSERT_UPDATE_USER_PREFERENCES: `${draftCombineUrl}/api/Common/InsUpdUnitPreferences`,
  INSERT_PLAYER_DETAILS: `${draftCombineUrl}/api/Players/InsNewPlayers`,
  GET_GAME_AUDIT_BLOBS: (EventId, LastModifiedDate) =>
    `${draftCombineUrl}/api/Common/GetGameAuditBlobsData/${EventId}/${LastModifiedDate}`,
  GET_GAME_AUDIT_REFRESH_TIME_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/56`,
  GET_REVISED_GAME_AUDIT_DISPLAY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/57`,
  INSERT_UPDATE_GAME_SCORE_DOCUMENT: `${draftCombineUrl}/api/Documents/InsUpdEventDocuments`,
  GET_GAME_SCORE_UPLOADED_DOCUMENTS: (eventId, sDocType) =>
    `${draftCombineUrl}/api/Documents/GetEventDocumentsDetails/${eventId}/${sDocType}`,
  GET_PLAYERS_COMPARISION_STATS_DATA: `${draftCombineUrl}/api/Players/GetCombinePlayersDataComparison`,
  GET_COUNTER_MOVEMENT_BY_PLAYER_ID: (eventId, stationId, playerId) =>
    `${draftCombineUrl}/api/Documents/GetCounterMovementsByPlayerId/${eventId}/${stationId}/${playerId}`,
  GET_COUNTER_MOVEMENTS_STATIONS: `${draftCombineUrl}/api/Common/GetEnumerationDetails/2`,
  INSERT_COUNTER_MOVEMENTS: `${draftCombineUrl}/api/Documents/InsCounterMovements`,
  GET_PLAYERS_STRENGTH_AND_AGILITY_DATA_BY_EVENTID: (eventId, userBy) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetCombinedResultsForStrengthAndAgilityByEventId/${eventId}`,
  GET_PLAYERS_ANTHROS_DATA_BY_EVENTID: (eventId, userBy) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetCombinedResultsForAnthrosByEventId/${eventId}/${userBy}`,
  GET_HISTORICAL_GC_DISPLAY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/60`,
  GET_GROUP_PERCENTILE_DISPLAY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/61`,
  GET_DEXA_BODY_FAT_DISPLAY_FLAG: `${draftCombineUrl}/api/Common/GetEnumerationDetails/62`,
  VERIFY_VOTTING_LIST: `${draftCombineUrl}/api/BallotVote/GetValidateTeamBallotVotes`,
  INSERT_PLAYER_MEDIA_DETAILS: `${draftCombineUrl}/api/AnthrosData/InsVideoFiles`,
  DELETE_PLAYER_MEDIA_DETAILS: `${draftCombineUrl}/api/Common/DeleteVideoCaptureData`,
  INSERT_NOTIFICATION_DETAILS: `${draftCombineUrl}/api/Notifications/InsNotification`,
  UPDATE_NOTIFICATION_DETAILS: `${draftCombineUrl}/api/Notifications/UpdNotification`,
  DELETE_NOTIFICATION_DETAILS: (notificationID, userBy) =>
    `${draftCombineUrl}/api/Notifications/DelNotification/${notificationID}/${userBy}`,
  GET_NOTIFICATION_DETAILS_BY_ID: (notificationID) =>
    `${draftCombineUrl}/api/Notifications/GetNotificationById/${notificationID}`,
  GET_SEARCH_NOTIFICATION_LIST: `${draftCombineUrl}/api/Notifications/GetSearchNotifications`,
  GET_DL_OPTION_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/63`,
  GET_EMAIL_STATUS_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/64`,
  GET_EMAIL_FROM_LIST: `${draftCombineUrl}/api/Common/GetEnumerationDetails/67`,
  SEND_DIRECT_NOTIFICATION: `${draftCombineUrl}/api/Notifications/ProcessNotifications`,
  GET_PLAYER_DETAILS_EXCEL_RESULT: () =>
    `${draftCombineUrl}/api/Players/GetPlayersProfileForExcel`,
  GET_COUNTER_MOVEMENT_URL: `${draftCombineUrl}/api/Common/GetEnumerationDetails/68`,
  SAVE_PLAYER_DEXABODYFAT_DOCUMENTS: `${draftCombineUrl}/api/Documents/InsUpdDexaBodyFatEventDocuments`,
  GET_DEXABODYFAT_URL_BY_ID: (docId) =>
    `${draftCombineUrl}/api/Documents/GetDexaBodyFatEventDocumentUrl/${docId}`,
  GET_INDIVIDUAL_COMPARISION_STATS_DATA: `${draftCombineUrl}/api/Players/GetGroupCombinePlayersDataComparison`,
  GET_SHUTTLE_RUN_LASER_TIME: (eventId) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetShuttleRunTrialAndLaserTime/${eventId}`,
  GET_PRO_LANE_LASER_TIME: (eventId) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetProLaneLaserTime/${eventId}`,
  GET_THREE_FOUR_LASER_TIME: (eventId) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetThreeFourLaserTime/${eventId}`,
  GET_EVENT_GAMES: `${draftCombineUrl}/api/EventGames/GetEventGames`,
  INSERT_EVENT_GAME: `${draftCombineUrl}/api/EventGames/InsEventGames`,
  UPDATE_EVENT_GAME: `${draftCombineUrl}/api/EventGames/UpdEventGames`,
  DELETE_EVENT_GAME: `${draftCombineUrl}/api/EventGames/DelEventGames`,
  GET_EVENT_GAME_TEAMS: `${draftCombineUrl}/api/EventGames/GetEventGameTeams`,
  INSERT_EVENT_GAME_TEAM: `${draftCombineUrl}/api/EventGames/InsEventGameTeams`,
  UPDATE_EVENT_GAME_TEAM: `${draftCombineUrl}/api/EventGames/UpdEventGameTeams`,
  DELETE_EVENT_GAME_TEAM: `${draftCombineUrl}/api/EventGames/DelEventGameTeams`,
  GET_EVENT_GAME_TEAM_PLAYERS: `${draftCombineUrl}/api/EventGames/GetEventGameTeamPlayer`,
  UPDATE_EVENT_GAME_TEAM_PLAYERS: `${draftCombineUrl}/api/EventGames/UpdEventGameTeamPlayer`,
  GET_CALENDER_EVENTS: `${draftCombineUrl}/api/CalendarEvents/GetCalendarEventsData`,
  ADD_UPDATE_CALENDAR_EVENT: `${draftCombineUrl}/api/CalendarEvents/InsUpdCalendarEvent`,
  DELETE_CALENDAR_EVENT: `${draftCombineUrl}/api/CalendarEvents/DelCalendarEvent`,
  GET_PUSH_NOTIFICATION_BY_USER: `${draftCombineUrl}/api/Notifications/GetPushNotificationsByUserId`,
  UPDATE_PUSH_NOTIFICATION: `${draftCombineUrl}/api/Notifications/UpdPushNotification`,
  DELETE_PUSH_NOTIFICATION: `${draftCombineUrl}/api/Notifications/DelPushNotification`,
  GET_PUSH_NOTIFICATION_TIMESTAMP: `${draftCombineUrl}/api/Common/GetEnumerationDetails/74`,
  GET_BALLOT_VOTE_SUBMISSION_EXCEL_REPORT: () =>
    `${draftCombineUrl}/api/BallotVote/GetBallotVoteSubmissionReport`,
  IS_SHOW_TEAM_ROSTERS: `${draftCombineUrl}/api/Common/GetEnumerationDetails/80`,
  GET_TEAM_ROSTERS: `${draftCombineUrl}/api/Common/GetEnumerationDetails/81`,
  GET_USER_ROLES: `${draftCombineUrl}/api/Common/GetRoles`,
  GET_TEAMS: `${draftCombineUrl}/api/Common/GetTeams`,
  ADD_UPDATE_USER: `${draftCombineUrl}/api/User/InsUpdUserWithRoles`,
  GET_ALL_USER_WITH_ROLES: `${draftCombineUrl}/api/User/GetUserWithRoles`,
  DELETE_USER_ROLE: `${draftCombineUrl}/api/User/DelUserRole`,
  GET_ANTHROS_CONSOLIDATED_LEADERS: (eventId) =>
    `${draftCombineUrl}/api/AnthrosData/GetAnthrosLeaderBoardByEventIdConsolidated/${eventId}`,
  GET_SAS_CONSOLIDATED_LEADERS: (eventId) =>
    `${draftCombineUrl}/api/StrengthAndAgility/GetStrengthAndAgilityLeaderBoardByEventIdConsolidated/${eventId}`,
  GET_SHOOTING_CONSOLIDATED_LEADERS: (eventId) =>
    `${draftCombineUrl}/api/ShootingDrills/GetShootingDrillLeaderBoardByEventIdConsolidated/${eventId}`,
  GET_5ON5_GAME_VIDEOS: `${draftCombineUrl}/api/GameVideos/GetGameVideos`,
  ADD_UPDATE_5ON5_GAME: `${draftCombineUrl}/api/GameVideos/InsUpdGameVideosAndPlayers`,
  DELETE_5ON5_GAME: `${draftCombineUrl}/api/GameVideos/DelGameVideosAndPlayers`,
};

export default APIURLConstants;
